module.exports = __webpack_public_path__ + "static/img-ne-vedem-315a1b08a08bc9469f0fac7dc19e10e5.png";